import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6c543565"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dispose-timeline__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-circle-check",
  style: {"font-size":"20px","color":"var(--el-color-primary)"}
}, null, -1))
const _hoisted_3 = { class: "dispose-timeline__text" }
const _hoisted_4 = { key: 1 }

import { useI18n } from 'vue-i18n'
import { formatTimeStamp } from '@/utils/time'
import { formatDisposeTimelineEntry } from '../labels'
import type { SafeEventDetailLog } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'dispose-timeline',
  props: {
    items: {}
  },
  setup(__props: any) {



const { t } = useI18n()

function showStatus (status?: number) {
  return status != null || status !== -1
}

function statusText (status?: number) {
  return t(`securityEvent.commandStatus.${status}`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_ctx.items.length)
    ? (_openBlock(), _createBlock(_component_el_timeline, {
        key: 0,
        class: "dispose-timeline"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              key: idx,
              timestamp: _unref(formatTimeStamp)(Number(item.handle_time) || 0, 'YYYY-MM-DD HH:mm:ss'),
              placement: "top",
              color: "var(--cm-color-primary)"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatDisposeTimelineEntry)(_unref(t), item)), 1),
                  (showStatus(item.status))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        size: "small",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(statusText(item.status)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["timestamp"]))
          }), 128))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))
}
}

})